import { t } from '@lingui/core/macro';
const createCategory = (data) => (Object.assign({ __typename: 'MetadataCategory', parentId: null, selectable: true }, data));
export function metadataCategories() {
    const other = createCategory({
        id: '1927154e-88b2-46a3-b566-c1d354473573',
        name: t({ message: 'Other', comment: 'Metadata category' }),
    });
    const categories = [
        createCategory({
            id: '726144ab-b785-4f7e-bd32-5b38f7d5dcdd',
            name: t({ message: 'Document Details', comment: 'Metadata category' }),
        }),
        createCategory({
            id: 'c3b3fa78-7a02-45fc-a4a4-5653aa5508b5',
            name: t({ message: 'Status & Lifecycle', comment: 'Metadata category' }),
        }),
        createCategory({
            id: 'cc4066c1-70dc-4eb3-8071-fa20e588d64c',
            name: t({ message: 'Key Terms', comment: 'Metadata category' }),
        }),
        createCategory({
            id: 'a3a08650-5234-446f-a24c-4b6ac307d6f5',
            parentId: 'cc4066c1-70dc-4eb3-8071-fa20e588d64c',
            name: t({ message: 'Commercial', comment: 'Metadata category' }),
        }),
        createCategory({
            id: '690da702-7ec6-41e7-bf81-ce116ea717e0',
            parentId: 'cc4066c1-70dc-4eb3-8071-fa20e588d64c',
            name: t({ message: 'Rights & Obligations', comment: 'Metadata category' }),
        }),
        createCategory({
            id: 'b3fa809a-875f-41af-bd9b-0eee5ea61b12',
            parentId: 'cc4066c1-70dc-4eb3-8071-fa20e588d64c',
            name: t({ message: 'Term & Termination', comment: 'Metadata category' }),
        }),
        createCategory({
            id: '09d64c50-8794-4758-b0d1-0a27f39b6cab',
            parentId: 'cc4066c1-70dc-4eb3-8071-fa20e588d64c',
            name: t({ message: 'Intellectual Property & Data', comment: 'Metadata category' }),
        }),
        createCategory({
            id: '41ec0ed9-b98a-4ed7-8dc3-e5321341652a',
            parentId: 'cc4066c1-70dc-4eb3-8071-fa20e588d64c',
            name: t({ message: 'Liability', comment: 'Metadata category' }),
        }),
        createCategory({
            id: 'adca7607-8784-4028-a514-bb1a1e014797',
            parentId: 'cc4066c1-70dc-4eb3-8071-fa20e588d64c',
            name: t({ message: 'Governing Law & Disputes', comment: 'Metadata category' }),
        }),
        createCategory({
            id: 'adc3e8ae-6804-498c-8300-f365e34adadb',
            parentId: 'cc4066c1-70dc-4eb3-8071-fa20e588d64c',
            name: t({ message: 'Other', comment: 'Metadata category' }),
        }),
        createCategory({
            id: 'eed2e292-abe3-457e-a24f-f8bba5d4ce91',
            name: t({ message: 'Access & Permissions', comment: 'Metadata category' }),
            selectable: false,
        }),
        other,
    ];
    return {
        get: (id) => categories.find((category) => category.id === id),
        getAll: () => categories,
        defaultCategory: () => other,
    };
}
